import { Permission, api } from 'api';
import { rtkQueryApi } from '../rtkQueryApi';

export const apiWithPermissions = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query<Permission[], void>({
      query: () => api.permission.getPermissions(),
    }),
  }),
});

export const { useGetPermissionsQuery } = apiWithPermissions;
